import SaveIcon from "./SaveIcon.mjs";

/** @type {GlyphIcon} */
export default SaveIcon;